export const ACCEPTED_FILE_TYPES = ".jpeg, .jpg, .png, .doc, .pdf, .gif, .rtf, .tif, .txt, .docx";

export const CARGO_ACCEPTED_FILE_TYPES =
  ".jpeg, .jpg, .png, .doc, .pdf, .gif, .rtf, .tif, .txt, .docx, .xls, .xlsx, .csv, .odf";
export const WC_SINGLE_FILE_MAX_SIZE = 6000000;
export const WC_ALL_FILES_MAX_SIZE = 29000000;

export const CARGO_SINGLE_FILE_MAX_SIZE = 50000000; // 50 MB
export const CARGO_ALL_FILES_MAX_SIZE = 300000000; // 300 MB

export const MAX_FILENAME_SIZE = 95;
